type TSchemaType = 'Product' | 'BreadcrumbList' | 'WebSite' | 'Organization'

type TBreadcrumbList = {
  name: string
  url: string
  position: number
}[]

type TBasicSchemaOrg = {
  type: TSchemaType
  name: string
  description?: string
  image?: string | string[]
  url: string
  breadCrumbList: TBreadcrumbList
  potentialAction?: {
    '@type': 'SearchAction'
    target: string
    'query-input': 'required name=search_term_string'
  }
}

type TProductSchema = {
  image: string
  productId: number | string
  price: number
  lowPrice: number
  highPrice: number
  availability: 'InStock' | 'OutOfStock'
} & Omit<TBasicSchemaOrg, 'image'>

// https://www.google.com/webmasters/markup-helper/u/0/?sjid=7094658595851150436-AP  這邊可以看到 Google 定義出來的 @type 種類
// https://search.google.com/test/rich-results/result 這邊可以測試自己的 schema 有什麼效果，只要把程式碼貼上

export const getProductSchemaOrg = ({
  name,
  description,
  image,
  productId,
  lowPrice,
  highPrice,
  price,
  availability,
  breadCrumbList,
}: TProductSchema) => {
  return [
    {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: name,
      image: image,
      description: description,
      productID: String(productId),
      brand: 'TutorABC',
      sameAs: ['https://www.facebook.com/tutorabcshop', 'https://www.instagram.com/tutorabcshop'],
      offers: {
        price: String(price),
        lowPrice: String(lowPrice),
        highPrice: String(highPrice),
        priceCurrency: 'TWD',
        availability: availability,
      },
    },

    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadCrumbList.map((item) => {
        return {
          '@type': 'ListItem',
          position: item.position,
          name: item.name,
          item: item.url,
        }
      }),
    },
  ]
}

export const getSchemaOrg = ({ type, name, description = '', breadCrumbList = [], url = '' }: TBasicSchemaOrg) => {
  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': type,
    name: name,
    description: description,
    url: url,
    sameAs: ['https://www.facebook.com/tutorabcshop', 'https://www.instagram.com/tutorabcshop'],
  }
  const breadCrumbListSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadCrumbList.map((item) => {
      return {
        '@type': 'ListItem',
        position: item.position,
        name: item.name,
        item: item.url,
      }
    }),
  }

  return [schemaOrg, breadCrumbListSchema]
}

/** JSON-LD 塞進 <script> 前把 < 轉成 \u003c，避免商品名／描述含 </script> 跳出 script 標籤執行 */
export const toJsonLd = (schema: unknown) => JSON.stringify(schema).replace(/</g, '\\u003c')
